import { push } from "connected-react-router";
import { Organization, useGetOrgsQuery, useGetOrgListItemQuery } from "generated/graphql";
import React, { FC, useState } from "react";
import { useDispatch } from "react-redux";
import { selectOrganization } from "routes/Organization/modules";
import { isNotNullOrUndefined } from "utils/isNotNullOrUndefined";
import { OrgSwitcher } from "./OrgSwitcher";
import { useRouteMatch } from "react-router-dom";
import { getRecentlyVisitedOrgs } from "components/RecentlyVisitedOrgs";

export interface OrgSwitcherContainerProps { }

export const OrgSwitcherContainer: FC<OrgSwitcherContainerProps> = () => {

    const match = useRouteMatch<{ organizationId?: string }>("/:organizationId");

    let organizationId: string;

    if (match) {
        organizationId = match.params.organizationId;
    }

    const [showItems, setShowItems] = useState<boolean>(false);
    const [search, setSearch] = useState<string>("");

    const [getOrgs] = useGetOrgsQuery({
        pause: !showItems,
        requestPolicy: "cache-and-network",
        variables: {
            from: 0,
            size: 12,
            withIdOrName: search ? search : undefined,
        },
    });

    const finished = !getOrgs.stale && getOrgs?.data?.orgs?.total

    const [orgData] = useGetOrgListItemQuery({
        pause: !organizationId || organizationId === "admin",
        requestPolicy: "cache-and-network",
        variables: {
            orgId: organizationId,
        },
    });

    const organizations =
        search !== "" ? getOrgs.data?.orgs?.orgs?.filter(isNotNullOrUndefined) || [] : getRecentlyVisitedOrgs() || [];
    const organization = orgData.data?.org;

    const fetching = orgData.fetching;
    const fetchingOrgs = getOrgs.fetching;

    const dispatch = useDispatch();

    function onSelectOrganization(organization: Organization) {
        dispatch(selectOrganization(organization));
        dispatch(push(`/${organization.organizationId}`));
    }

    return (
        <OrgSwitcher
            orgs={organizations}
            organization={organization}
            orgsTotal={getOrgs.data?.orgs?.total}
            isLoading={fetching}
            isLoadingItems={fetchingOrgs}
            search={search}
            onSearchChange={setSearch}
            onSelectOrganization={onSelectOrganization}
            onShowItemsChange={setShowItems}
            showItems={showItems}
            finished={finished}
        />
    );
};
